module.exports = __webpack_public_path__ + "img/preview eye (2).cf266b1f.svg";